export const WORKSHOP_PARTICIPANTS_LIST_DISABLED = 0,
    WORKSHOP_PARTICIPANTS_LIST_ENABLED = 1,
    WORKSHOP_PARTICIPANTS_LIST_SELECTED_ONLY = 2;

export function isSessionParticipantsListEnabled(session, eventSettings) {
    const {workshop_participants_list} = eventSettings;

    if (workshop_participants_list) {
        if (workshop_participants_list === WORKSHOP_PARTICIPANTS_LIST_SELECTED_ONLY) {
            return session.is_selected;
        }

        // workshop_participants_list is either true or WORKSHOP_PARTICIPANTS_LIST_ENABLED
        return true;
    }

    // settings value is either false or WORKSHOP_PARTICIPANTS_LIST_DISABLED
    return false;
}
